import React, { cloneElement } from 'react';
import { InternalGrid, Text } from '@paygreen/paygreen-ui';

const CategoryTitle = ({ category, icon, children }) => {
    let categoryIcon = null;

    if (icon) {
        categoryIcon = cloneElement(icon, {
            iconSize: 'md',
            marginRight: 'sm',
        });
    }

    return (
        <InternalGrid
            justifyContent="flex-start"
            alignItems="center"
            flexWrap="nowrap"
        >
            {categoryIcon}

            <Text htmlTag="strong" textSize="sm">
                {category}

                {children}
            </Text>
        </InternalGrid>
    );
};

export default CategoryTitle;
